import { createOrderedGroups } from './groupsAndCategories';

/**
 * Create navigation links for each group of permissions
 */
export const createNavLinks = (roleId: string) => {
  const orderedGroups = createOrderedGroups();
  return orderedGroups.map((group) => ({
    exact: true,
    name: group.name,
    pathname: `/roles/${roleId}`,
    hash: `#${group.id}`,
  }));
};
